import { faComment } from '@fortawesome/pro-regular-svg-icons/faComment';
import LegacyNpsButton from 'studio5/components/AgentStudioLinkOut/LegacyNpsButton';
import type { LinkOutContent, LinkOutRoute } from './types';

export const NPS_CONTENT: LinkOutContent = {
  title: 'NPS',
  heading: 'Manage modern NPS in the new App',
  message: 'Modern NPS surveys have moved to the new Appcues App.',
  icon: faComment,
  secondaryAction: LegacyNpsButton,
};

const routes: LinkOutRoute[] = [
  {
    // Only the list: NPS 2.0 builder, analytics and settings stay in Studio.
    // Gated on `NPS_2_0` alone, not the `AGENT_STUDIO*` flags.
    pattern: /^\/nps-v2\/?$/i,
    resolve: () => '/experiences?types=NPS',
    content: NPS_CONTENT,
    flags: ['NPS_2_0'],
    examples: ['/nps-v2', '/nps-v2/'],
  },
];

export default routes;
